import {AiContentVerificationErrorCode} from '@Libraries/ai-content-verification.types';

export const AI_CONTENT_VERIFY_ROOT_ID = 'ai-content-verify-root';

export interface AiContentVerifyProps {
  maxMediaUploadBytes: number;
  maxHtmlUploadBytes: number;
}

export interface AiContentVerifyUploadLimits {
  mediaLimit: string;
  htmlLimit: string;
}

export const ACCEPTED_FILE_EXTENSIONS: readonly string[] = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'tif', 'tiff', 'pdf', 'mp4', 'mov', 'webm', 'm4a', 'mp3', 'html', 'htm'];
export const HTML_FILE_EXTENSIONS: readonly string[] = ['html', 'htm'];
export const FILE_INPUT_ACCEPT = ACCEPTED_FILE_EXTENSIONS.map((extension) => {
  return `.${extension}`;
}).join(',');

export const BYTES_PER_MEGABYTE = 1048576;
export const MEGABYTE_UNIT = 'megabyte';
export const LOCALE_SEPARATOR_FROM_I18NEXT = '_';
export const LOCALE_SEPARATOR_FOR_INTL = '-';

export const FAILURE_MESSAGE_KEYS: Record<AiContentVerificationErrorCode, string> = {
  [AiContentVerificationErrorCode.UPLOAD_MISSING]: 'pmwjs_ai_verify_error_missing',
  [AiContentVerificationErrorCode.UPLOAD_TOO_LARGE]: 'pmwjs_ai_verify_error_too_large',
  [AiContentVerificationErrorCode.UNSUPPORTED_FILE]: 'pmwjs_ai_verify_error_unsupported',
  [AiContentVerificationErrorCode.UPLOAD_REJECTED]: 'pmwjs_ai_verify_error_rejected',
  [AiContentVerificationErrorCode.RATE_LIMITED]: 'pmwjs_ai_verify_error_rate_limited',
  [AiContentVerificationErrorCode.TOO_MANY_CONCURRENT_REQUESTS]: 'pmwjs_ai_verify_error_busy',
};

export const GENERIC_FAILURE_MESSAGE_KEY = 'pmwjs_ai_verify_error_generic';
